import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AuthProvider } from '../context/AuthContext';
import { ThemeProvider } from '../context/ThemeContext';
import { NotificationProvider } from '../context/NotificationContext';
import { ContentVisibilityProvider } from '../context/ContentVisibilityContext';
import ToastContainer from '../components/common/ToastContainer';
import '../styles/print.css';
import '../styles/layout-mobile.css';
const AppProviders = ({ children }) => {
    const recaptchaSiteKey = typeof process !== 'undefined'
        ? String(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '').trim()
        : '';
    const appTree = (React.createElement(ThemeProvider, null,
        React.createElement(NotificationProvider, null,
            React.createElement(AuthProvider, null,
                React.createElement(ContentVisibilityProvider, null,
                    children,
                    React.createElement(ToastContainer, null))))));
    return (React.createElement(HelmetProvider, null, recaptchaSiteKey ? (React.createElement(GoogleReCaptchaProvider, { reCaptchaKey: recaptchaSiteKey, scriptProps: { async: true, defer: true, appendTo: 'head' } }, appTree)) : (appTree)));
};
export default AppProviders;
